"use client";

import CurrencyInputBase, {
  CurrencyInputProps,
} from "react-currency-input-field";

import { Input } from "./input";

export const CurrencyInput = (props: CurrencyInputProps) => (
  <CurrencyInputBase
    {...props}
    allowNegativeValue={false}
    allowDecimals
    decimalsLimit={2}
    intlConfig={{
      locale: "pt-BR",
      currency: "BRL",
    }}
    decimalSeparator=","
    groupSeparator="."
    className="h-9"
    customInput={Input}
  />
);
